import type { ComputedRef } from 'vue';

import { SaleType } from '~/apiClient';

type UseSaleTypeReturn = {
    isMonoAsset: ComputedRef<boolean>;
    isBundle: ComputedRef<boolean>;
    isBundleMono: ComputedRef<boolean>;
    isBundleMulti: ComputedRef<boolean>;
    isMonoVersion: ComputedRef<boolean>;
    isToBeScraped: ComputedRef<boolean>;
};

export const useSaleType = (type: MaybeRefOrGetter<SaleType>): UseSaleTypeReturn => ({
    isMonoAsset: computed(() => getSaleTypeInfo(toValue(type)).isMonoAsset),
    isBundle: computed(() => getSaleTypeInfo(toValue(type)).isBundle),
    isBundleMono: computed(() => getSaleTypeInfo(toValue(type)).isBundleMono),
    isBundleMulti: computed(() => getSaleTypeInfo(toValue(type)).isBundleMulti),
    isMonoVersion: computed(() => getSaleTypeInfo(toValue(type)).isMonoVersion),
    isToBeScraped: computed(() => getSaleTypeInfo(toValue(type)).isToBeScraped),
});
